import ModelBaseClass from "@quasidea/oas-client-react/lib/ModelBaseClass";
import VaultReportedAmount from "../VaultReportedAmount";
import ModelProxyClass from "./ModelProxyClass";
import AmountDetails from "../AmountDetails";


/**
 * @class VaultReportedAmountBase
 * @extends ModelBaseClass
 * @property {number} reportedAmount
 * @property {AmountDetails} reportedDetails
 * @property {number} discrepancyAmount
 */
class VaultReportedAmountBase extends ModelBaseClass {
	/**
	 * @type {number} reportedAmount
	 */
	reportedAmount;
	/**
	 * @type {AmountDetails} reportedDetails
	 */
	reportedDetails;
	/**
	 * @type {number} discrepancyAmount
	 */
	discrepancyAmount;

	/**
	 * Instantiates a new instance of VaultReportedAmount based on the generic object being passed in (typically from a JSON object)
	 * @param {object} genericObject
	 * @return {VaultReportedAmount}
	 */
	static create(genericObject) {
		const newVaultReportedAmount = new VaultReportedAmount();
		newVaultReportedAmount.instantiate(_modelDefinition, genericObject, ModelProxyClass.createByClassName);
		return newVaultReportedAmount;
	}

	/**
	 * Instantiates a new array of VaultReportedAmount based on the generic array being passed in (typically from a JSON array)
	 * @param {[object]} genericArray
	 * @return {[VaultReportedAmount]}
	 */
	static createArray(genericArray) {
		if (genericArray === null) {
			return null;
		}

		const newVaultReportedAmountArray = [];
		genericArray.forEach(genericObject => {
			newVaultReportedAmountArray.push(VaultReportedAmount.create(genericObject));
		});
		return newVaultReportedAmountArray;
	}
}

const _modelDefinition = [
	ModelBaseClass.createModelProperty('reportedAmount', 'float'),
	ModelBaseClass.createModelProperty('reportedDetails', 'AmountDetails'),
	ModelBaseClass.createModelProperty('discrepancyAmount', 'float'),
];

export default VaultReportedAmountBase;
